<template>
  <v-card :loading="loading">
    <v-toolbar dense flat color="accent" dark>
      <v-toolbar-title>
        사용자 목록
      </v-toolbar-title>
      <v-spacer/>
    </v-toolbar>
    <v-card-text>
      <v-data-table
        :headers="headers"
        :items="items"
        :items-per-page="10"
        :options.sync="options"
        :server-items-length="totalCount"
        class="elevation-1"
        :loading="loading"
        :footer-props="{
          'items-per-page-options':[10, 20, 30],
          'items-per-page-text': ''
        }"
        must-sort
        item-key="id"
        locale="ko"
      >
        <template v-slot:item.createdAt="{ item }">
          <display-time :time="item.createdAt" />
        </template>
        <template v-slot:item.updatedAt="{ item }">
          <display-time :time="item.updatedAt" />
        </template>
        <template v-slot:item.visitedAt="{ item }">
          <display-time :time="item.visitedAt" />
        </template>
        <template v-slot:item.email="{ item }">
          <v-chip color="secondary">
            <v-avatar left>
              <v-img v-if="item.photoURL" :src="item.photoURL"></v-img>
              <v-icon v-else>mdi-lock-open</v-icon>
            </v-avatar>
            {{item.email}}
          </v-chip>
        </template>
      </v-data-table>

    </v-card-text>

  </v-card>
</template>
<script>
import { head, last } from 'lodash'
import DisplayTime from '@/components/display-time'

export default {
  components: { DisplayTime },
  data () {
    return {
      loading: false,
      docs: [],
      headers: [
        { text: '이메일', value: 'email' },
        { text: '가입일', value: 'createdAt' },
        { text: '수정시간', value: 'updatedAt' },
        { text: '권한', value: 'level' },
        { text: '방문횟수', value: 'visitCount' },
        { text: '최근방문일', value: 'visitedAt' }
      ],
      items: [],
      totalCount: 0,
      options: {
        sortBy: ['createdAt'],
        sortDesc: [false]
      },
      unsubscribe: null,
      unsubscribeCount: null,
      refUsers: null
    }
  },
  watch: {
    options: {
      handler (n, o) {
        if (!o.page) {
          this.subscribe(0)
          return
        }
        const arrow = n.page - o.page
        this.subscribe(arrow)
      },
      deep: true
    }
  },
  created () {
    this.subscribeCount()
  },
  destroyed () {
    if (this.unsubscribe) this.unsubscribe()
    if (this.unsubscribeCount) this.unsubscribeCount()
  },
  methods: {
    onError (e) {
      this.loading = false
      this.$toast.error(e.message)
    },
    subscribeCount () {
      this.loading = true
      this.unsubscribeCount = this.$firebase.firestore().collection('meta').doc('users').onSnapshot((doc) => {
        this.loading = false
        if (!doc.exists) return
        this.totalCount = doc.data().count
      }, this.onError)
    },
    subscribe (arrow) {
      this.refUsers = this.$firebase.firestore().collection('users')
      const order = this.options.sortBy[0]
      const sort = this.options.sortDesc[0] ? 'desc' : 'asc'
      const limit = this.options.itemsPerPage
      const ref = this.refUsers.orderBy(order, sort)
      let query
      switch (arrow) {
        case -1: query = ref.endBefore(head(this.docs)).limitToLast(limit)
          break
        case 1: query = ref.startAfter(last(this.docs)).limit(limit)
          break
        default: query = ref.limit(limit)
          break
      }
      this.loading = true
      this.unsubscribe = query.onSnapshot((sn) => {
        this.loading = false
        if (sn.empty) {
          this.items = []
          return
        }
        this.docs = sn.docs
        this.items = sn.docs.map(doc => {
          const item = doc.data()
          item.id = doc.id
          item.createdAt = item.createdAt.toDate()
          item.updatedAt = item.updatedAt.toDate()
          item.visitedAt = item.visitedAt.toDate()
          return item
        })
      }, this.onError)
    }

  }
}
</script>
